import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const Half = ({ to, bg, kicker, title, line, testid }) => (
  <Link to={to} data-testid={testid}
    className={`group relative flex min-h-[340px] flex-1 flex-col justify-between overflow-hidden p-8 text-white transition-[flex-grow] duration-700 ease-out sm:p-12 md:min-h-[460px] md:hover:flex-[1.6] ${bg}`}>
    <span className="font-mono-x text-xs uppercase tracking-[0.22em] text-white/90">{kicker}</span>
    <div>
      <h3 className="font-display text-5xl font-bold leading-[0.9] tracking-[-0.03em] sm:text-6xl lg:text-7xl">{title}</h3>
      <p className="mt-5 max-w-sm text-base text-white/90">{line}</p>
    </div>
    <ArrowUpRight className="absolute right-8 top-8 h-12 w-12 transition-transform duration-500 group-hover:rotate-45 group-hover:scale-125" />
  </Link>
);

export const SplitCTA = () => (
  <section className="flex flex-col md:flex-row" data-testid="split-cta">
    <Half to="/clients" bg="bg-[#FF4D1A]" kicker="for hiring teams" title={<>i need<br />people.</>} line="Tell us the role. Hear back inside the hour. Names inside five." testid="cta-hire-link" />
    <Half to="/talent" bg="bg-[#2234F5]" kicker="for engineers & specialists" title={<>i am<br />the people.</>} line="You've done the work. Let us put it in front of someone who'll notice." testid="cta-talent-link" />
  </section>
);
